<template>
  <div class="mobile">
    <div class="fullbox">
      <div class="search">
        <el-input
          v-model="search"
          placeholder="输入关键词..."
          @input="searchList"
          clearable
        ></el-input>
        <img src="@/assets/logistics/search.png" alt="" />
        <!-- <img @click="toBackend" src="@/assets/logistics/backend.png" alt="" /> -->
        <img :src="$store.state.userInfo.icon" alt="" />
      </div>
      <div class="list" v-loading="loading">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            class="list_item"
            v-for="(item, index) in list"
            :key="index"
            @click="toLogistics(item)"
          >
            <div class="left">
              <img :src="url + item.image" alt="" />
            </div>
            <div class="right">
              <div class="title">{{ item.title }}</div>
              <!-- <div class="con" v-html="item.content"></div> -->
              <div class="rightBot">
                <div class="type">{{ item.name }}</div>
                <div class="time">{{ item.timeAgo }}</div>
              </div>
            </div>
          </div>
        </van-list>
        <!-- <div v-html="value"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis/logistics";
export default {
  components: {},
  data() {
    return {
      search: "",
      list: [],
      url: "https://hydt.nvc-lighting.com.cn/",
      page: 1,
      pageSize: 20,
      totalAll: 0,
      loading: false,
      finished: false,
      searchTimer: null, // 存储定时器
    };
  },
  mounted() {},
  methods: {
    // 搜索
    searchList() {
      clearTimeout(this.searchTimer); // 清除之前的定时器，防止多次执行
      this.searchTimer = setTimeout(() => {
        this.page = 1;
        this.getList();
      }, 1000); // 设置延迟 500ms，可根据需求调整
    },
    //跳转到详情
    toLogistics(item) {
      this.$router.push({
        path: "/logistics/logisticsDetail",
        query: {
          id: item.id,
        },
      });
    },
    onLoad() {
      this.getList();
    },
    //获取列表数据
    getList() {
      this.loading = true;
      api
        .queryArticleList({
          keyWord: this.search,
          menuId: "",
          page: this.page,
          pageSize: this.pageSize,
        })
        .then((res) => {
          if (res.code == 200) {
            this.total = res.data.total;
            this.finished = false;
            if (this.page === 1) {
              this.list = res.data.list;
            } else {
              this.list = this.list.concat(res.data.list);
            }
            if (this.list.length < this.total) {
              this.page = this.page + 1;
            } else {
              this.finished = true;
            }
            this.loading = false;
            // this.list = this.list.map((item) => {
            //   item.useSaterTime = moment(item.useSaterTime).format(
            //     "YYYY-MM-DD HH:mm"
            //   );
            //   item.useEndTime = moment(item.useEndTime).format(
            //     "YYYY-MM-DD HH:mm"
            //   );
            //   return item;
            // });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .fullbox {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .fullbox {
    width: 276px * $zoom;
    background: #f7f9fa;
    ::v-deep {
      .van-dropdown-item {
        width: 276px * $zoom !important;
        margin: auto;
      }
    }
  }
}
.mobile {
  width: 100%;
  display: flex;
  justify-content: center;
}
.fullbox {
  font-size: 14px * $zoom;
  position: relative;
  height: 100vh;
  overflow: hidden;
  padding-top: 40px;
  .search {
    background: #fff;
    border-radius: 40px;
    padding: 0 0 0 20px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 90%;
    margin: auto;
    img {
      width: 55px;
      height: 55px;
      margin-right: 32px;
    }
    img:nth-child(3) {
      border-radius: 50%;
    }
    ::v-deep {
      .el-input {
        height: 100%;
      }
      .el-input__inner {
        height: 100%;
        background: #fff;
        border: none;
        font-size: 32px;
        color: rgba(125, 133, 146, 1);
      }
    }
  }
  .bar {
    width: 100%;
    background: #fff;
    border-radius: 30px;
    height: 180px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 25px;
    margin-top: 40px;
    img {
      width: 48%;
      height: 100%;
    }
  }
  .tab {
    ::v-deep {
      //   .van-dropdown-menu__title--active {
      //     color: #000;
      //     position: relative;
      //   }
      .active {
        color: #000;
        position: relative;
        &::before {
          content: "";
          display: block;
          width: 35px;
          height: 5px;
          background: rgba(78, 162, 124, 1);
          position: absolute;
          border-radius: 10px;
          bottom: -20px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
      .van-dropdown-menu__bar {
        background: none !important;
        box-shadow: none !important;
        height: 120px;
      }
      .van-dropdown-menu__title::after {
        border-color: transparent transparent #000 #000;
      }
    }
  }
  .list {
    width: 90%;
    height: calc(100vh - 240px);
    margin: auto;
    overflow: auto;
    margin-top: 30px;
    // 隐藏滚动条
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .list_item {
      background: #fff;
      border-radius: 40px;
      padding: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      // height: 240px;
      margin-bottom: 30px;
      .left {
        width: 36.5%;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
          border-radius: 20px;
        }
      }
      .right {
        width: 70%;
        height: 100%;
        padding-left: 30px;
        .title {
          font-weight: bold;
          font-size: 30px;
        }
        .con {
          font-size: 25px;
          color: rgba(102, 102, 102, 1);
          margin: 10px 0;
          display: -webkit-box; /* 需要组合使用 */
          -webkit-box-orient: vertical; /* 设置为垂直方向 */
          -webkit-line-clamp: 2; /* 显示两行 */
          overflow: hidden; /* 隐藏多余的文本 */
          text-overflow: ellipsis; /* 溢出时显示省略号 */
        }
        .rightBot {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          margin-top: 30px;
          .type {
            color: rgba(78, 162, 124, 1);
            background: rgba(78, 162, 124, 0.1);
            padding: 10px 20px;
            border-radius: 20px;
            font-size: 25px;
          }
          .time {
            font-size: 25px;
            color: rgba(102, 102, 102, 1);
          }
        }
      }
    }
  }
}
</style>
